export default __webpack_public_path__ + "static/media/MilkTeaPouring4.e498632e.gif";